import { all, call, put, select, takeLatest } from 'redux-saga/effects'
import actions from '../Delivery/actions';

import Bugsnag from '@bugsnag/js';
import { getRequest, postRequest } from '@components/config/axiosClient';

export const getQuote = (state) => state.checkoutQuoteReducer.quote;
export const getDetails = (state) => state.checkoutDetailsReducer.details;

function* getInstallDerig(action) {
  const quote = yield select(getQuote);
  const cartProducts = quote?.cart?.map(i => i.id);
  const cartQty = quote?.cart?.map(i => i.qty);
  try {
    const response = yield call(() => postRequest('quote/transport', {
      brand: process.env.brand.brand_key,
      cart_products: cartProducts,
      cart_qty: cartQty,
      'delivery-postcode': quote.deliveryPostcode,
      'collection-postcode': quote.collectionPostcode,
      'cart-total-weight': quote.cartTotalWeight,
      'delivery-date-timestamp': quote.deliveryDateTimestamp,
      'collection-date-timestamp': quote.collectionDateTimestamp
    }));
    yield put({ type: actions.DELIVERY_GET_INSTALL_DERIG_SUCCESS, payload: response.data });
  } catch (error) {
    Bugsnag.notify(error);
    yield put({ type: actions.DELIVERY_GET_INSTALL_DERIG_FAILURE, payload: error });
  }
}

function* getSurcharges(action) {
  const quote = yield select(getQuote); //grab the current state of the quote
  const details = yield select(getDetails); //grab the current state of the quote
  const delPostcode = details?.deliveryPostcode && details?.deliveryPostcode != "" ? details.deliveryPostcode : quote.deliveryPostcode;
  const colPostcode = details?.collectionPostcode && details?.collectionPostcode != "" ? details.collectionPostcode : quote.collectionPostcode;
  //turn collectionDate and deliveryDate to timestamps
  const collectionDate =
    details?.collectionDate
      ? Math.floor(Date.parse(details.collectionDate) / 1000)
      : quote?.collectionDate
        ? Math.floor(Date.parse(quote.collectionDate) / 1000)
        : null;

  const deliveryDate =
    details?.deliveryDate
      ? Math.floor(Date.parse(details.deliveryDate) / 1000)
      : quote?.deliveryDate
        ? Math.floor(Date.parse(quote.deliveryDate) / 1000)
        : null;


  //send an api req to get the current pricing of surcharges and store them in the state
  try {
    const params = new URLSearchParams({
      brand: process.env.brand.brand_key,
      'delivery-postcode': delPostcode,
      'collection-postcode': colPostcode,
    });

    if (collectionDate !== null && !Number.isNaN(collectionDate)) {
      params.append('collection-date-timestamp', collectionDate);
    }

    if (deliveryDate !== null && !Number.isNaN(deliveryDate)) {
      params.append('delivery-date-timestamp', deliveryDate);
    }
    const response = yield call(() => getRequest('surcharges?' + params.toString()));
    yield put({ type: actions.DELIVERY_GET_SURCHARGES_SUCCESS, payload: response.data });
  } catch (error) {
    Bugsnag.notify(error);
    yield put({ type: actions.DELIVERY_GET_SURCHARGES_FAILURE, payload: error });
  }
}

export default function* rootSaga() {
  yield all([takeLatest(actions.DELIVERY_GET_SURCHARGES, getSurcharges)]);
  yield all([takeLatest(actions.DELIVERY_GET_INSTALL_DERIG, getInstallDerig)]);
}
